import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/auth/AuthGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutContent"] */ "/vercel/path0/components/layout/LayoutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/components/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationProvider"] */ "/vercel/path0/components/providers/NavigationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileProvider"] */ "/vercel/path0/components/providers/ProfileProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/providers/SessionProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
